import { ActionIcon, Tooltip } from "@dehub/theme";
import type { ComponentType, ReactNode } from "react";
import { ReasonTooltip } from "./reason-tooltip";

type Props = Readonly<{
  label: string;
  /** Why the action is unavailable; shown as the tooltip and read by screen readers. Null when enabled. */
  reason: ReactNode;
  icon: ComponentType<{ size?: number; weight?: "bold" | "regular" }>;
  /** Marks the button so a page can return focus to it when the drawer it opened closes. */
  anchor: string;
  onClick: () => void;
  /** Tone for an action whose meaning is its colour (activate = green, deactivate = red); grey otherwise. */
  color?: "gray" | "green" | "red";
}>;

/** A subtle icon button for a table row (grey unless `color` is set). Unavailable ones stay focusable and say why (ReasonTooltip). */
export function RowAction({ label, reason, icon: Icon, anchor, onClick, color = "gray" }: Props) {
  const button = (
    <ActionIcon
      variant={color === "gray" ? "subtle" : "light"}
      color={color}
      size={30}
      aria-label={label}
      data-row-action={anchor}
      onClick={onClick}
    >
      <Icon size={16} />
    </ActionIcon>
  );
  return reason ? (
    <ReasonTooltip reason={reason}>{button}</ReasonTooltip>
  ) : (
    <Tooltip label={label} withArrow>
      {button}
    </Tooltip>
  );
}
